<template>
  <header class="emi-index-header">
    <a href="/" class="emi-index-logo"></a>
    <nav class="emi-index-nav">
      <ul class="emi-index-nav-list">
        <li class="emi-index-nav-item" v-for="nav in navList" :key="nav.path" :class="{'active': ruouteName === nav.id}">
          <a class="nav-link" :href="nav.path"> {{nav.name}}</a>
          <i class="iconfont iconicondaochu-2" v-if="nav.icon"></i>
          <div class="child-nav-box" v-if="nav.child">
            <ul class="child-nav-list">
              <li class="child-nav-item" v-for="child in nav.child" :key="child.path" :class="{'active': ruouteName === child.id || subName == child.id}">
                <a :href="child.path"> {{child.name}}</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
    <div class="emi-index-account" v-if="!isLogin">
      <span class="emi-index-login">
        <a href="/index/logined"> 登录</a>
      </span>
      <span class="emi-index-register">
        <i class="iconfont iconEMI-11"></i>
        <span>
          <a href="https://account.xiaomi.com/pass/register"> 注册</a>
        </span>
      </span>
    </div>
    <div class="emi-index-account" v-else>
      <span class="emi-index-link">
        <a href="/ad" v-if="isCoreAgent"> 管理中心</a>
        <span class="openAccount" @click="dialogVisible=true" v-else>开户</span>
      </span>
      <span class="emi-index-link">
        <a href="/account/logout"> 退出</a>
      </span>
    </div>
   <el-dialog title="开户" :visible.sync="dialogVisible" width="30%" append-to-body class="open-account-dialog">
      <div>
       <p>请选择开户方式</p>
        <div class="dialog-content">
          <el-button class="btn" :type="openType === 'agent' ? 'primary' : 'default'"
            @click="selectAccount('agent')">通过核心代理商开户</el-button>
          <el-button class="btn" :type="openType === 'invite' ? 'primary' : 'default'" @click="selectAccount('invite')"
            disabled>通过邀请码自助开户</el-button>
          <div class="dialog-content-input">
            <el-input placeholder="请输入客户经理提供的邀请码" v-if="openType === 'invite'" v-model="code" disabled></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="footer_btn" @click="dialogVisible = false">取 消</el-button>
        <el-button class="footer_btn" type="primary" @click="openType === 'agent' ? goTodetailUrl() : submitCode()">确
          定</el-button>
      </span>
    </el-dialog>
  </header>
</template>
<script>
  import cookie from '../common/cookie.js';
  import axios from '../common/axios.js';
  export default {
    name: 'common-header',
    data() {
      return {
        userId:cookie.getCookie('userId') || '',
        dialogVisible:false,
        openType: 'agent',
        code:'',
        detailUrl:window.location.origin + '/#/core-agent',
        isCoreAgent:true,
        navList: [
          {name: '首页', path: '/', id: 'index'},
          {name: '资源介绍', path: '#/resource/shop', icon: true, id: 'resource', child: [
            {name: '应用商店', path: '#/resource/shop', id: 'shop'},
            {name: '信息流媒体', path: '#/resource/browser', id: 'browser'},
            {name: '小米视频', path: '#/resource/video', id: 'video'},
            {name: '手机管家', path: '#/resource/safe', id: 'safe'},
          ]},
          {name: '帮助中心', path: '/v2/dist/help.html'},
          {name: '推广合作', path: '#/core-agent', icon: true, id: 'combination', child: [
            {name: '核心代理商', path: '#/core-agent', id: 'agent'},
            {name: '营销认证', path: '#/authentication/introduce', id: 'auth'}
          ]},
          {name: '开放平台', path: '/v2/dist/api.html'},
          {name: '营销课堂', path: '/v2/dist/course.html'}
        ],
        isLogin: false
      }
    },
    computed: {
      ruouteName() {
        return this.$route.name;
      },
      subName() {
        return this.$route.params.type;
      }
    },
  methods: {
    openAccountDialog() {
      this.dialogVisible = true;
      this.openType = 'agent';
    },
    selectAccount(type) {
      this.openType = type;
    },
    goTodetailUrl() {
      if (this.openType === 'agent') {
        window.location.href = this.detailUrl
      }
      this.dialogVisible = false;
      console.log(this.detailUrl, '111111111111111111');
    },
    submitCode() {
      this.dialogVisible = false;
    },
    async getOpenStatus() {
      if (!this.userId) return;
      try{
        const res = await axios({
            url: '/v5/account/getOpenStatus',
            method: 'get',
            params: {userId:this.userId}
          });
          if(!res.result){
            this.isCoreAgent = false
          }
      }catch(err){

      }
    }
  },
    created() {
      this.isLogin = !!cookie.getCookie('userId');
      this.getOpenStatus();
    }
  }
</script>